var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertasPersonalizados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alertas-personalizados",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alertas-personalizados_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ftMLWX.tif_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.4,52.1c0.5-2.1,1.1-4.1,2.4-5.8c2.4-3.1,5.6-4.8,9.5-4.9c1.7-0.1,3.4,0,5.1,0c0-2.7,0-5.4,0-8.1 c2.7,0,5.4,0,8.2,0c0,2.6,0,5.3,0,8c17.9,0,35.7,0,53.7,0c0-2.6,0-5.3,0-8c2.8,0,5.4,0,8.2,0c0,2.7,0,5.3,0,8.1 c1.2,0,2.3,0,3.5,0c3.2-0.1,6.3,0.5,8.9,2.6c3,2.3,4.7,5.4,4.7,9.2c0.1,8.8,0,17.6,0,26.4c0,0.1,0,0.3-0.1,0.4c-2.7,0-5.3,0-8,0 c0-2.8,0-5.6,0-8.4c-29.3,0-58.6,0-87.9,0c0,0.3,0,0.5,0,0.8c0,17.3,0,34.6,0,51.9c0,3.4,1.5,4.9,5,4.9c11,0,22,0,33,0 c0.6,0,1.1,0,1.9,0c0,2.7,0,5.4,0,8.1c-12.4,0-24.8,0-37.2,0c-0.2-0.1-0.3-0.1-0.5-0.2c-3.4-0.5-6-2.2-8-5 c-1.3-1.7-1.8-3.6-2.3-5.7C33.4,101.7,33.4,76.9,33.4,52.1z M120.5,49.5c0,2.8,0,5.4,0,8c-2.8,0-5.4,0-8.2,0c0-2.7,0-5.3,0-8 c-17.9,0-35.8,0-53.7,0c0,2.7,0,5.4,0,8c-2.7,0-5.4,0-8.1,0c0-2.7,0-5.4,0-8.1c-1.6,0-3.2,0-4.7,0c-2.5,0-4.2,1.7-4.2,4.2 c0,2.1,0,4.1,0,6.2c0,1.1,0,2.2,0,3.3c29.3,0,58.6,0,87.8,0c0-3.4,0.1-6.7,0-10c-0.1-2.1-1.8-3.6-3.9-3.7 C123.9,49.4,122.3,49.5,120.5,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,137.3c-1.1-0.4-2.1-1-2.7-2c-1.1-2-0.5-4.4,1.5-5.5c0.3-0.2,0.6-0.3,1.1-0.5c-7.8,0-15.4,0-23,0 c0-2.9-0.2-5.7,0.5-8.5c0.7-3,2.1-5.6,4.2-7.9c0.8-0.9,1.2-1.9,1.2-3.1c0-2.9-0.2-5.9,0.2-8.7c1-7.5,5.3-12.4,12.5-14.9 c0.3-0.1,0.6-0.2,1-0.3c0.1,0,0.2-0.1,0.3-0.1c0-1.8,0-3.6,0-5.5c2.7,0,5.4,0,8.1,0c0,1.8,0,3.7,0,5.2c2.1,1.1,4.2,1.9,6,3.1 c5,3.3,7.6,8.1,8,14.1c0.1,2.2,0.1,4.5,0,6.7c0,1.5,0.4,2.8,1.5,4c2.9,3.2,4.3,6.9,4.4,11.2c0,1.6,0,3.2,0,4.9 c-7.6,0-15.2,0-22.6,0c0.7,0.7,1.7,1.4,2.2,2.3c1.2,2,0.2,4.6-1.9,5.5c-0.3,0.1-0.5,0.2-0.8,0.4 C113.8,137.3,113.3,137.3,112.7,137.3z M98.3,121c10.3,0,20.3,0,30.5,0c-0.8-1.1-1.3-2-2.1-2.8c-2.4-2.6-3.3-5.6-3.2-9 c0-2.1,0-4.1,0-6.2c-0.2-4.8-4.2-9.1-8.8-9.5c-6.1-0.5-11,4-11.1,10.1c0,2.4,0,4.7,0,7.1c-0.1,2.7-1,5-2.7,7.1 C100,118.6,99.3,119.7,98.3,121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.9,88c0-2.7,0-5.3,0-8c2.7,0,5.3,0,8,0c0,2.6,0,5.3,0,8C54.3,88,51.7,88,48.9,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,80c2.7,0,5.3,0,8,0c0,2.7,0,5.3,0,8c-2.7,0-5.3,0-8,0C65.2,85.4,65.2,82.8,65.2,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.5,80c2.7,0,5.3,0,8,0c0,2.7,0,5.3,0,8c-2.6,0-5.3,0-8,0C81.5,85.4,81.5,82.7,81.5,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,104.3c-2.7,0-5.3,0-8,0c0-2.7,0-5.3,0-8c2.6,0,5.3,0,8,0C57,98.9,57,101.6,57,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,96.3c2.7,0,5.3,0,8,0c0,2.6,0,5.3,0,8c-2.6,0-5.3,0-8,0C65.2,101.6,65.2,99,65.2,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,104.3c-2.7,0-5.3,0-8,0c0-2.7,0-5.3,0-8c2.6,0,5.3,0,8,0C89.5,98.9,89.5,101.6,89.5,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.9,120.6c0-2.7,0-5.3,0-8c2.7,0,5.3,0,8,0c0,2.7,0,5.3,0,8C54.3,120.6,51.7,120.6,48.9,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,112.5c2.7,0,5.3,0,8,0c0,2.7,0,5.3,0,8c-2.6,0-5.3,0-8,0C65.2,117.9,65.2,115.3,65.2,112.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertasPersonalizados);
export default __webpack_public_path__ + "static/media/alertas-personalizados.58c3d266e77dedf0e6cc510c2d0c78d6.svg";
export { ForwardRef as ReactComponent };